export default __webpack_public_path__ + "static/media/Monkey.b7ad4d03.png";